import { SET_TRACKING_DETAILS } from "./actionTypes";

export const setTrackingDetails = value => ({
  type: SET_TRACKING_DETAILS,
  value
});
